export const AppConstants = {
  LzwCompressionResponseHeaderName: 'x-ascs-compressed',
  // AuthzGlobalEntitlementsContext: 'global',
  // PartyTypes: {
  //   Subcode: 'Subcode',
  //   Client: 'Client',
  // },
};
